import { ref, watch } from 'vue'
import axios from './Axios';
import { addProcess } from './Processor';

class PermissionDefinitionApi {
    constructor() {
        this.isDirty = ref(false);
        this.isLoading = ref(false);
        this.isSaving = false;

        if (!window.Api)
            window.Api = {};
        window.Api.PermissionDefinitionAxi = axios;
        window.Api.PermissionDefinition = this;
    }

    // eslint-disable-next-line
    async beforeSave(data) {
    }

    // eslint-disable-next-line
    async afterLoad(data) {
    }

    async get(id) {
        this.isLoading.value = true;
        let result = await axios.get('/api/permissiondefinitions/' + id);
        await this.afterLoad(result.data);
        let dataRef = this.attachWatchers(result.data);
        return dataRef;
    }

    async getByKey(key) {
        this.isLoading.value = true;
        let result = await axios.get('/api/permissiondefinitions/byKey/' + encodeURIComponent(key));
        await this.afterLoad(result.data);
        let dataRef = this.attachWatchers(result.data);
        return dataRef;
    }

    async getAll() {
        this.isLoading.value = true;
        let result = (await axios.getBuffered('/api/permissiondefinitions/')).data;
        await this.afterLoad(result);
        this.isLoading.value = false;
        let dataRefs = this.attachWatchers(result);
        return dataRefs;
    }

    async createNew(defaultValues) {
        let data = {
            Key: '',
            Area: '',
            Group: '',
            Action: '',
            Label: '',
            Description: '',
            SortOrder: 0
        };

        if (defaultValues)
            Object.assign(data, defaultValues);

        return this.attachWatchers(data);
    }

    async save(data) {
        let process = addProcess("Save PermissionDefinition: " + (data.Key || data._id || 'new'));
        await this.beforeSave(data);
        let result = await axios.post('/api/permissiondefinitions/', data).finally(() => process());
        return result.data;
    }

    async delete(data) {
        let key = data;
        if (typeof (data) === "object")
            key = data._id;

        let process = addProcess("Delete PermissionDefinition: " + ((typeof data === "object" && data.Key) ? data.Key : key));
        let result = await axios.delete('/api/permissiondefinitions/' + key).finally(() => process());
        return result.data;
    }

    attachWatchers(data) {
        if (Array.isArray(data))
            return data.map(i => this.attachWatchers(i));

        let dataRef = ref(data);
        this.isLoading.value = false;

        watch(dataRef.value, async () => {
            if (this.isSaving)
                return;

            this.isDirty.value = true;
            this.isSaving = true;

            let newData = await this.save(dataRef.value);
            Object.assign(dataRef.value, newData);

            setTimeout(() => {
                this.isSaving = false;
            }, 1);

            this.isDirty.value = false;
        });

        return dataRef.value;
    }
}

let permissionDefinitionApi = new PermissionDefinitionApi();

export { permissionDefinitionApi, PermissionDefinitionApi }
export default permissionDefinitionApi;